import {
  GET_PROFILE_SUCCESS,
  GET_SERVICE_ELIGIBILITY_FAILURE,
  GET_SERVICE_ELIGIBILITY_SUCCESS,
  SIGN_OUT_SUCCESS,
} from '../constants'

const initState = {
  isSignedIn: false,
  isBabyClubMember: false,
  profile: {
    additionalInfo: {
      firstName: '',
    },
  },
}

export default (state = initState, action) => {
  switch (action.type) {
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        ...action.response,
        isSignedIn: action.response.profileId.length > 0,
      }
    case SIGN_OUT_SUCCESS: {
      return {
        ...state,
        isSignedIn: false,
        isBabyClubMember: false,
      }
    }
    case GET_SERVICE_ELIGIBILITY_SUCCESS: {
      return {
        ...state,
        ...action.response,
      }
    }
    case GET_SERVICE_ELIGIBILITY_FAILURE: {
      return {
        ...state,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./services/app-state/profile/reducer/index.js